(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9657,2012,1586],{

/***/ 99404:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[...categorySlugs]",
      function () {
        return __webpack_require__(88673);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Page_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2952);
/* harmony import */ var _yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32012);







var NotFoundLayout = function(param) {
    var staticContent = param.staticContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Page_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                staticContent: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, staticContent), {
                    metaTags: {
                        title: "P\xe1gina no encontrada",
                        shouldIndex: false,
                        dismissSeoTags: true
                    }
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_4__["default"], {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundLayout);


/***/ }),

/***/ 88673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_initializeUserContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22514);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37555);
/* harmony import */ var components_catalog_YDSCatalog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77319);
/* harmony import */ var layouts_NotFound_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51586);
/* harmony import */ var layouts_Page_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2952);
/* harmony import */ var _yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52177);











var Catalog = function(param) {
    var staticContent = param.staticContent, selectedCategory = param.selectedCategory, currentNavCategory = param.currentNavCategory, currentPage = param.currentPage, facetsKeys = param.facetsKeys;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var authToken = (0,_yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v)(function(param) {
        var authentication = param.authentication;
        return authentication.token;
    });
    var dispatch = (0,_yema_commerce_StoreClient__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return (0,utils_initializeUserContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            authToken: authToken,
            dispatch: dispatch
        });
    }, [
        authToken,
        router.asPath
    ]);
    if (!selectedCategory) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_NotFound_layout__WEBPACK_IMPORTED_MODULE_6__["default"], {
        staticContent: staticContent
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_Page_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        staticContent: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, staticContent), {
            metaTags: {
                title: ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.page) > 1 ? "Resultados p\xe1gina ".concat(router.query.page, " para ") : "") + (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(selectedCategory, [
                    "name"
                ], "Cat\xe1logo"),
                canonicalUrl: (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.page) > 1 ? "".concat(("https://yema.mx" + router.asPath).split(/[?#]/)[0], "?page=").concat(router.query.page) : null
            }
        }),
        currentCategory: currentNavCategory,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_catalog_YDSCatalog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            content: selectedCategory,
            currentPage: currentPage,
            facetsKeys: facetsKeys
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Catalog);


/***/ }),

/***/ 66483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37555);





/**
 * Use our custom loader on Google Cloud Functions, linked to Google Storage
 * instead of next default loader
 */ var customLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return sf_modules__WEBPACK_IMPORTED_MODULE_3__/* .imageTools.getOptimizedImageURL */ .d$.getOptimizedImageURL(src, {
        w: width,
        q: quality || 70
    });
};
var Image = function(props) {
    if (!props || !props.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var imageLoader = props.src.startsWith("https://us-central1-yema-") ? {
        loader: customLoader
    } // YEMA CDN Loader
     : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, imageLoader, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 4740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Image__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66483);



/***/ }),

/***/ 32012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ NotFound_NotFound; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Button/index.js + 1 modules
var Button = __webpack_require__(62772);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/NotFound/NotFound.jsx










var NOT_FOUND_IMAGE = "https://us-central1-yema-cdn.cloudfunctions.net/cdn/api/v1/yema-plm/images/view/assets/yema-image-notfound.png";
var NotFound = function(_param) {
    var className = _param.className, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()("relative h-96 md:h-[607px]", className)
            }, otherProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "center",
                        src: NOT_FOUND_IMAGE,
                        alt: "La p\xe1gina que buscas no existe"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-0 w-full py-6 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "\xa1Ups! Parece que llegaste a un lugar inesperado"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "No pasa nada"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variants: "primary",
                                    size: "sm",
                                    type: "button",
                                    children: "Regresar al inicio"
                                })
                            })
                        ]
                    })
                ]
            }))
        ]
    });
};
NotFound.defaultProps = {};
NotFound.propTypes = {};
/* harmony default export */ var NotFound_NotFound = (NotFound);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/NotFound/index.js



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9097,6577,1673,2952,6029,9774,2888,179], function() { return __webpack_exec__(99404); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);